import React, { useState, useEffect, useRef } from "react";
import { GoogleMap, MarkerF, InfoWindowF } from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "500px",
};

const DEFAULT_CENTER = { lat: 28.6139, lng: 77.2090 };

export default function GoogleMapView({ path = [] }) {
  const mapRef = useRef(null);
  const [currentLocation, setCurrentLocation] = useState(null);
  const [selectedPoint, setSelectedPoint] = useState(null);

  // Get device location
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setCurrentLocation({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        },
        (error) => console.error("LOCATION ERROR:", error)
      );
    }
  }, []);

  // Auto-fit bounds to show all dots dynamically
  useEffect(() => {
    if (!mapRef.current || !path || path.length === 0) return;

    const bounds = new window.google.maps.LatLngBounds();
    path.forEach((point) => {
      if (point.lat && point.lng) {
        bounds.extend(new window.google.maps.LatLng(point.lat, point.lng));
      }
    });

    mapRef.current.fitBounds(bounds);
  }, [path]);

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={currentLocation || DEFAULT_CENTER}
      zoom={12}
      onLoad={(map) => { mapRef.current = map; }}
      options={{
        zoomControl: true,
        scrollwheel: true,
        gestureHandling: "greedy",
        fullscreenControl: true,
      }}
    >
      {/* Admin's own current position marker */}
      {currentLocation && (
        <MarkerF position={currentLocation} label="You" />
      )}

      {/* Render history coordinates as small clean dots */}
      {path.map((point, index) => (
        <MarkerF
          key={index}
          position={{ lat: point.lat, lng: point.lng }}
          icon={{
            path: window.google?.maps?.SymbolPath?.CIRCLE,
            scale: 6, // Size of the point dot
            fillColor: "#007bff", // Nice modern blue
            fillOpacity: 0.9,
            strokeWeight: 2,
            strokeColor: "#ffffff", // White border around the dot
          }}
          onClick={() => setSelectedPoint({ ...point, index })}
        />
      ))}

      {/* Modern Pop-up Card when a point is clicked */}
      {selectedPoint && (
        <InfoWindowF
          position={{ lat: selectedPoint.lat, lng: selectedPoint.lng }}
          onCloseClick={() => setSelectedPoint(null)}
        >
          <div style={popupCardStyle}>
            <div style={popupHeaderStyle}>📍 Capture Point #{selectedPoint.index + 1}</div>
            <div style={popupRowStyle}>
              <span style={popupLabelStyle}>Date:</span>
              <span style={popupValueStyle}>
                {selectedPoint.created_at 
                  ? new Date(selectedPoint.created_at).toLocaleDateString([], { month: 'short', day: 'numeric', year: 'numeric' })
                  : "N/A"}
              </span>
            </div>
            <div style={popupRowStyle}>
              <span style={popupLabelStyle}>Time:</span>
              <span style={popupValueStyle}>
                {selectedPoint.created_at 
                  ? new Date(selectedPoint.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
                  : "N/A"}
              </span>
            </div>
          </div>
        </InfoWindowF>
      )}
    </GoogleMap>
  );
}

// ===============================
// POPUP POP-UP STYLES
// ===============================
const popupCardStyle = {
  padding: "4px",
  minWidth: "160px",
  fontFamily: "'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
};

const popupHeaderStyle = {
  fontSize: "12px",
  fontWeight: "bold",
  color: "#333",
  borderBottom: "1px solid #eee",
  paddingBottom: "6px",
  marginBottom: "8px",
};

const popupRowStyle = {
  display: "flex",
  justifyContent: "space-between",
  marginBottom: "4px",
  fontSize: "11px",
};

const popupLabelStyle = {
  color: "#777",
  fontWeight: "500",
};

const popupValueStyle = {
  color: "#222",
  fontWeight: "600",
};